import Const from "../js/const";

export function otaTaskStatus(val, to = 'key') {
    const MAP = Const.OTA_TASK.STATUS_MAP
    const ITEM = MAP[val + ''] || { key: "c.unknown" }
    return ITEM[to] || ''
}

export function otaTaskMemberStatus(val, to = 'key') {
    const MAP = Const.OTA_TASK.MEMBER_STATUS_MAP
    const ITEM = MAP[val + ''] || { lkey: "c.unknown" }
    return ITEM[to] || ''
}

export function otaTargetTypeStatus(val, to = 'key') {
    const MAP = Const.OTA_TASK.TARGET_TYPE_MAP
    const ITEM = MAP[val + ''] || { lkey: "c.unknown" }
    return ITEM[to] || ''
}


export function otaTaskMemberProgress(taskMember, mult = 100) {
    if (!taskMember.total_count) {
        return Number(taskMember.progress).toFixed(2) * mult + "%"
    } else {
        return ((Number(taskMember.finish_count) / Number(taskMember.total_count)).toFixed(2)) * mult  + "%"
    }
}


export function taskUpgradeStatusFilter(val, to = 'key') {
    const MAP = Const.OTA_TASK.UPGRADE_STATUS_MAP
    const ITEM = MAP[val + ''] || { key: "task.upgrade_status.leisure" }
    return ITEM[to] || ''
}